import { IField } from 'app/services/api5-service/api.interface';
import { Observable, combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { ISPFormState } from 'common/dynamic-form/model';
import { getHint } from 'common/dynamic-form/utils/get-hint';
import { DocHelper } from 'utils/dochelper';

/**
 * Get stream of hint msg for field
 *
 * @param field
 * @param state
 */
export function getFieldHint$(
  field: IField,
  state: ISPFormState,
): Observable<string | undefined> {
  return combineLatest([
    state.docSubject,
    state.conditionService.isHidden$(field.$name),
    // @TODO i.ablov add disabled hint displaying
    // state.disabledService.isFieldDisabled$(field.$name),
  ]).pipe(
    map(([doc, isShadow]) => {
      let hintMsg = getHint(field.$name, doc, state.showHints);

      if (isShadow) {
        const shadowHintMsg = DocHelper.getMessage(
          `shadow_hint_${field.$name}`,
          doc,
        );

        if (shadowHintMsg) {
          hintMsg = `${
            hintMsg || ''
          } </br></br><strong>${shadowHintMsg}</strong>`;
        }
      }

      return hintMsg;
    }),
    shareReplay({
      refCount: true,
      bufferSize: 1,
    }),
  );
}
